const ListsHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex w-full items-center justify-center gap-2">
      {children}
    </div>
  );
};

export default ListsHeader;
